<div class="sales-line-panel">
    <div class="panel-head">
        <div class="panel-title">
            <span class="panel-title-icon tone-blue">
                <span class="material-icons-outlined">trending_up</span>
            </span>
            <div>
                <strong>Monthly Sales Numbers</strong>
                <small>Reservation, seat and cancellation trend</small>
            </div>
            <span class="sales-integrated-badge">Sales Report</span>
        </div>
        <div class="line-legend">
            <span><i style="background: #49a765"></i>Reservation <b>{{ totalReservations() }}</b></span>
            <span><i style="background: #3974df"></i>Seat <b>{{ totalSeats() }}</b></span>
            <span><i style="background: #e05a67"></i>Cancel <b>{{ totalCancels() }}</b></span>
        </div>
    </div>

    @if (loading()) {
        <div class="chart-loading">
            <p-progress-spinner strokeWidth="5" [style]="{ width: '30px', height: '30px' }" />
        </div>
    } @else {
        <div class="sales-line-body">
            <p-chart type="line" [data]="chartData()" [options]="chartOptions"></p-chart>
        </div>
    }
</div>
